import {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomButton, {
  atomButtonAlignment,
  atomButtonDesigns,
  atomButtonShapes,
  atomButtonSizes
} from '@s-ui/react-atom-button'
import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'
import {useMediaQuery, useMediaQueryBreakpoints} from '@adv-mt/mt-layout-render-media-query'

import {useUtils} from '../../hooks/useUtils.js'

const BASE_CLASS = 'mt-PanelFinancing'

export const PanelFinancingLenderInfo = ({
  ad,
  handleOnClickCtaTerms,
  isPrivate,
  loanCalculations,
  onContactSellerCtaClick,
  showContactSellerCta
}) => {
  const {domain, i18n} = useContext(Context)

  const config = domain.get('config')
  const URL_STATICS_IMAGES = config.get('URL_STATICS_IMAGES')

  const {lender} = loanCalculations || {}
  const {handleScrollToContactSeller} = useUtils()
  const isMobile = !useMediaQuery(useMediaQueryBreakpoints.lg)

  const legalTextLink = isPrivate ? 'SHOW_LEGAL_TERMS' : 'FINANCING_INFO.SHOW_LEGAL_CONDITIONS'

  const handleClickContactSellerCTA = () => {
    handleScrollToContactSeller({ad})
    onContactSellerCtaClick?.()
  }

  return (
    <div className={`${BASE_CLASS}-lenderInfo`}>
      <div className={`${BASE_CLASS}-lenderInfoProvider`}>
        <span>{i18n.t('FINANCING_INFO.PROVIDED_BY')}</span>
        {lender && <AtomImage alt={lender} src={`${URL_STATICS_IMAGES}common/logos/${lender}.svg`} />}
      </div>
      <div className={`${BASE_CLASS}-lenderInfoCta`}>
        <AtomButton
          alignment={atomButtonAlignment.LEFT}
          design={atomButtonDesigns.LINK}
          onClick={handleOnClickCtaTerms}
          size={atomButtonSizes.MEDIUM}
        >
          {i18n.t(legalTextLink)}
        </AtomButton>
      </div>
      {showContactSellerCta && isMobile && (
        <AtomButton
          design={atomButtonDesigns.OUTLINE}
          fullWidth
          onClick={handleClickContactSellerCTA}
          shape={atomButtonShapes.CIRCULAR}
          size={atomButtonSizes.MEDIUM}
        >
          {i18n.t('PANEL_FINANCING.CONTACT_SELLER_CTA')}
        </AtomButton>
      )}
    </div>
  )
}

PanelFinancingLenderInfo.propTypes = {
  ad: PropTypes.object,
  handleOnClickCtaTerms: PropTypes.func,
  isPrivate: PropTypes.bool,
  loanCalculations: PropTypes.object,
  onContactSellerCtaClick: PropTypes.func,
  showContactSellerCta: PropTypes.bool
}
